// ============================================================
// useFees Hook
// ============================================================

import { useQuery } from '@tanstack/react-query';
import { useSchool } from './useSchool';
import { feeService } from '@/services/feeService';

export function usePendingFees(filters = {}) {
  const { currentSchool } = useSchool();

  return useQuery({
    queryKey: ['pendingFees', currentSchool?.id, filters],
    queryFn: () => feeService.getPendingFees(currentSchool.id, filters),
    enabled: !!currentSchool?.id,
    select: (res) => res.data,
  });
}
